import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DialerSipIcon(props: IconProps) {
    return <Icon {...props} iconKey={"dialer_sip"}/>
}
